const API_BASE = '/api';

function extractErrorMessage(data, status) {
  if (!data || typeof data !== 'object') {
    return `请求失败 (${status})`;
  }
  if (typeof data.error === 'string' && data.error) {
    return data.error;
  }
  const detail = data.detail;
  if (typeof detail === 'string' && detail) {
    return detail;
  }
  return `请求失败 (${status})`;
}

async function request(path, options = {}) {
  const { method = 'GET', body, headers, ...rest } = options;
  const response = await fetch(`${API_BASE}${path}`, {
    method,
    body,
    headers: { 'Content-Type': 'application/json', ...(headers || {}) },
    ...rest,
  });
  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, error: `请求失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  return data;
}

async function uploadFile(path, file) {
  const safeName = (file?.name || '').trim() || 'upload.xls';
  const form = new FormData();
  form.append('file', file, safeName);
  form.append('original_name', safeName);
  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, { method: 'POST', body: form });
  } catch {
    return { ok: false, error: '网络异常，上传失败' };
  }
  const raw = await response.text();
  let data;
  try {
    data = raw ? JSON.parse(raw) : {};
  } catch {
    return { ok: false, error: `上传失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  return data;
}

export const cji3CostApi = {
  getState: () => request('/cji3/state'),
  upload: (file) => uploadFile('/cji3/upload', file),
  export: () => request('/cji3/export', { method: 'POST' }),
  reset: () => request('/cji3/reset', { method: 'POST' }),
  downloadUrl: (filename) => `${API_BASE}/cji3/download/${encodeURIComponent(filename)}`,
};
